export const HEADING_TEXT = 'Where should we send your order?'
export const REST_OF_THE_WORLD_TEXT = 'Rest of World'
export const TITLE_TEXT = 'Go to Moonpig home'
export const IMAGE_WIDTH = '120'
export const IMAGE_HEIGHT = '138'
